// DS: PO24
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal, { MODAL_FOOTER_BUTTON_SIZE } from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import s from './PromptModal.scss';
export const PromptModal = ({ initialInputValue = '', isOpen, title, inputLabel, doneButtonLabel, inputWrapperClassName, extrasBeforeInput, maxLength, minLength, confirmDisabled: confirmDisabledProp, onInputValidate, onCancel, onDone })=>{
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState(initialInputValue);
    const [confirmState, setConfirmState] = useState('ready');
    const [cancelState, setCancelState] = useState('ready');
    const errorHint = inputValue !== initialInputValue && onInputValidate ? onInputValidate(inputValue) : undefined;
    const onInputKeyUp = (ev)=>{
        if (!errorHint && ev.key === 'Enter' && !confirmDisabled) {
            onDoneHandler();
        }
    };
    const onDoneHandler = ()=>onDone && onDone(inputValue);
    const onClickConfirm = ()=>{
        setConfirmState('busy');
        setCancelState('disabled');
        onDoneHandler();
    };
    const confirmDisabled = !!errorHint || confirmDisabledProp || (minLength ? inputValue.length < minLength : false) || confirmState === 'disabled';
    const confirmLoading = confirmState === 'busy';
    return /*#__PURE__*/ React.createElement(Modal, {
        className: s['root'],
        isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : false,
        onRequestClose: ()=>onCancel && onCancel(),
        heading: title,
        footerRight: [
            /*#__PURE__*/ React.createElement(TextButton, {
                key: "cancel-btn",
                onClick: ()=>{
                    setConfirmState('disabled');
                    setCancelState('busy');
                    onCancel && onCancel();
                },
                size: MODAL_FOOTER_BUTTON_SIZE,
                variant: "main",
                loading: cancelState === 'busy',
                disabled: cancelState === 'disabled'
            }, t('popup.cancel')),
            /*#__PURE__*/ React.createElement(BrandedButton, {
                key: "confirm-btn",
                size: MODAL_FOOTER_BUTTON_SIZE,
                variant: "brand-green",
                disabled: confirmDisabled,
                onClick: onClickConfirm,
                loading: confirmLoading
            }, doneButtonLabel || t('popup.done'))
        ]
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['content-wrapper']
    }, extrasBeforeInput, /*#__PURE__*/ React.createElement("div", {
        className: inputWrapperClassName
    }, /*#__PURE__*/ React.createElement(TextInput, {
        id: "prompt-modal-input",
        value: inputValue,
        label: inputLabel || '',
        validationResult: errorHint ? 'error' : undefined,
        details: errorHint,
        onChange: (ev)=>setInputValue(ev.target.value),
        onKeyUp: onInputKeyUp,
        maxLength: maxLength,
        isLabelHidden: !inputLabel,
        autoFocus: true
    }))));
};
PromptModal.displayName = 'PromptModal';
export default PromptModal;

//# sourceMappingURL=PromptModal.js.map